import Image from 'next/image'
import React from 'react'
import { BaseCard } from '../BaseCard'

export const FeaturedLearnMoreRaceCard = ({ imageUrl, tag, title, subTitle }) => {
    return (
        <BaseCard cardType="tall" boxShadow={false} onClick={null} href={null}>
            <Image
                alt={`Races Learn More card image`}
                src={
                    imageUrl
                        ? imageUrl
                        : 'https://res.cloudinary.com/yes-fit/image/upload/v1636051055/manual/yes-fit-learn-more-about-virtual-races.png'
                }
                layout="fill"
                objectFit="cover"
                className="bg-gray-800"
            />
            <div className="flex flex-col pt-10 z-10 absolute top-3 left-5">
                <p className="text-yf-light-blue text-[10px] font-normal">
                    {tag ? tag : 'FITNESS'}
                </p>
                <p className="mt-2 mb-1.5 text-white text-3xl font-medium leading-none tracking-wide">
                    {title ? (
                        title
                    ) : (
                        <>
                            Virtual
                            <br />
                            Races
                        </>
                    )}
                </p>
                <p className="text-sm font-normal text-white max-w-[120px]">
                    {subTitle
                        ? subTitle
                        : 'Join virtual races designed around popular themes. Workout at your own pace and earn unique medals, coins, t-shirts, & more!'}
                </p>
                <div>
                    <a
                        href="https://yesfit.app.link/racepagecarouselios"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src="https://asset.yes.fit/homepage/AppStoreBadge.png"
                            className="mt-3 mb-1 max-h-[36px]"
                        />
                    </a>
                    <a
                        href="https://yesfit.app.link/racepagecarouselandroid"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src="https://asset.yes.fit/homepage/PlaystoreBadge.png"
                            className="max-h-[36px]"
                        />
                    </a>
                </div>
            </div>
        </BaseCard>
    )
}
